import { render, staticRenderFns } from "./OrderDia.vue?vue&type=template&id=7ac0ad84&scoped=true"
import script from "./OrderDia.vue?vue&type=script&lang=js"
export * from "./OrderDia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac0ad84",
  null
  
)

export default component.exports